import React, {createContext, useContext} from 'react';
import {useChat} from '../hooks/useChat';
import type {AgentOption, ChatSession} from '../types/chatTypes';
import {observer} from "mobx-react-lite";

type ChatContextType = {
    sessions: ChatSession[];
    currentSession: ChatSession | null;
    hasReceivedFinalMessage: boolean;
    isRestoringSession: boolean;
    /** Clears session-restore loading (e.g. when leaving the chat page). */
    clearSessionLoading: () => void;
    isWaiting: boolean;
    availableAgents: AgentOption[];
    selectedAppName: string;
    setSelectedAppName: (appName: string) => void;
    sendMessage: (content: string, bagId?: number) => Promise<void>;
    selectSession: (session: ChatSession) => void;
    startNewChat: (initialMessage?: string, bagId?: number) => void;
    restoreSession: (sessionId: string) => Promise<ChatSession | null>;
    updateSessionName: (sessionId: string, name: string) => void;
    removeSession: (sessionId: string) => void;
};

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export const ChatProvider: React.FC<{children: React.ReactNode}> = observer(({children}) =>
    <ChatContext.Provider value={useChat()}>{children}</ChatContext.Provider>
)

export const useChatContext = () => {
    const context = useContext(ChatContext);
    if (context === undefined) {
        throw new Error('useChatContext must be used within a ChatProvider');
    }
    return context;
};
